const LANGUAGES = {
  DANISH: "da",
  ENGLISH: "en"
};
export {
  LANGUAGES
};
